import React from 'react';
import { ShoppingCart } from 'lucide-react';
import Reveal from './Reveal';

export default function Grocery({ t }) {
  const g = t.grocery;

  return (
    <section className="relative bg-ink py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-0 right-1/4 w-[400px] h-[400px] rounded-full bg-pulse-500/8 blur-[140px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="max-w-3xl mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-volt-400/40 bg-volt-400/10 text-volt-400 text-xs font-bold uppercase tracking-[0.18em] mb-5">
              <ShoppingCart size={14} />
              {g.kicker}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-frost tracking-tight leading-tight">
              {g.title}
            </h2>
            <p className="mt-5 text-lg text-mist leading-relaxed">{g.sub}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {g.steps.map((step, i) => (
            <Reveal key={i} delay={(i % 3) * 90}>
              <div className="group relative h-full rounded-3xl border border-line bg-surface p-7 overflow-hidden hover:border-volt-400/40 transition-all duration-300">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-volt-400 to-pulse-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="flex flex-col gap-4">
                  <span className="font-display text-sm font-bold text-volt-400 tracking-[0.2em]">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <p className="text-frost/90 leading-relaxed font-medium">{step}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
